import React, { Component } from 'react';
export class ThankyouSubscription extends Component {
    displayName = ThankyouSubscription.name
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        var doc = window.parent.parent.document;

    }
    render() {
        return (
            <div className="col-12">
                <div className="row">
                    <div className="col-lg-8 colPadding margintop">
                        <p style={{ border: "1px solid", paddingLeft: '3%', paddingTop: '3%', paddingBottom: '3%' }}> Thank you for contacting us.
                        <br></br> <br></br>
                           <span style={{fontStyle:'italic'}}> We will respond shortly. </span>
                        <br></br> <br></br>
                            <span style={{fontStyle:'italic'}}>  If you would like to contact customer service directly, you can do so via the following methods:</span>
                        <br></br> <br></br>
                             <span style={{fontStyle:'italic'}}> Tel: +31 (0)172 64 1562 (CET 9:00-17:00)</span>
                          <br></br> <br></br>
                          <span style={{ fontStyle: 'italic' }}> Email:  <a href={"mailto:dawn.danish@wolterskluwer.com"} style={{ textDecoration: 'underline' }} target="_blank"> lrs-sales@wolterskluwer.com</a> </span>

                        </p>
                        <br></br>
                        <a href="/"><button className="btn back-btn"><span className="oi oi-chevron-left pr-1"></span>Back to Kluwer Law Online</button></a>
                        <div className="White">
                        </div>
                        <div className="White">
                        </div>
                        <div className="White">
                        </div>
                        <div className="White">
                        </div>
                        <div className="White">
                        </div>
                    </div >
                </div >
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer Section/ThankyouSubscription.jsx